// Lightweight route preloader to make initial navigation to heavy pages feel faster.
// It mirrors the dynamic imports defined in `src/routes.tsx` so Vite reuses the same chunks.
// Safe to call on hover/focus – it only warms the browser cache.

const routePreloaders: Record<string, () => Promise<unknown>> = {
  // Management
  '/organizations': () => import('../pages/Organizations'),
  '/feature-management': () => import('../pages/FeatureToggle'),

  // Monitoring
  '/coding-metrics': () => import('../pages/CodingMetrics'),
  '/webhooks': () => import('../pages/WebhookInsights'),
  '/integration-stats': () => import('../pages/IntegrationStats'),
  '/incremental-sync': () => import('../pages/IncrementalSync'),
  '/jira-sync': () => import('../pages/JiraSync'),
  '/active-syncs': () => import('../pages/ActiveSyncs'),
  '/repo-insights': () => import('../pages/RepoInsights'),
  '/author-insights': () => import('../pages/AuthorInsights'),
  '/missing-data-insights': () => import('../pages/MissingDataInsights'),
  '/data-ingestion': () => import('../pages/DataIngestion'),

  // Infrastructure
  '/ecs-deployments': () => import('../pages/EcsDeployments'),
  '/migration': () => import('../pages/Migration'),
};

export const prefetchRoute = (path: string) => {
  const loader = routePreloaders[path];
  if (!loader) return;

  // Fire-and-forget – do not block UI on prefetch.
  void loader();
};


